import React from "react";
import { Card, CardBody } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "./tour-card.css";

const TourCardBlock = ({ tour, buttonText }) => {
  const { name, category, image, featured, city} = tour;

  const navigate = useNavigate(); // Initialize useNavigate

  const navigateToTourDetails = (tourCategory, tourName) => {
    if (tourCategory && tourName) {
      const categorySlug = tourCategory.split(" ").join("-").toLowerCase();
      const tourNameSlug = tourName.split(" ").join("-").toLowerCase();
      navigate(`/tour-packages/${categorySlug}/${tourNameSlug}`);
    }
  };

  return (
    <div className="tour__card">
      <Card className="mb-4">
        <div className="tour__img">
          <img src={image} alt="tour-img" />
          {featured && <span>Featured</span>}
        </div>

        <CardBody>
          <div className="card__top d-flex align-items-center justify-content-between">
            <span className="tour__location d-flex align-items-center gap-1">
              <i className="ri-map-pin-line"></i> {city}
            </span>
          </div>
          <h5 className="tour__title">
            <Link
              to={`/tour-packages/${category
                ? category.split(" ").join("-").toLowerCase()
                : ""}/${name
                ? name.split(" ").join("-").toLowerCase()
                : ""}`}
            >
              {name}
            </Link>
          </h5>

          <div className="card__bottom d-flex align-items-center justify-content-between mt-3">
            <button
              className="btn booking__btn"
              onClick={() => navigateToTourDetails(category, name)}
            >
              {buttonText}
            </button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default TourCardBlock;
